<template>
  <LogCardWrapper
    variant="danger"
    icon="x"
    title="Usunięta"
    :date="formatDate(log.created_at)"
  >
    <div class="log-row" v-if="log.user0">
      <b-icon icon="person-fill" class="log-icon text-muted" />
      <span>{{ log.user0.name }}</span>
    </div>
    <div class="log-row">
      <b-icon icon="telephone-fill" class="log-icon text-muted" />
      <a :href="`tel:${log.string0}`" class="text-body">{{ log.string0 }}</a>
    </div>
    <div class="log-row">
      <b-icon icon="calendar-event" class="log-icon text-muted" />
      <span>{{ formatDate(log.date0_at) }}</span>
    </div>
    <div class="log-row" v-if="log.schedule0 && log.schedule0.barber">
      <b-icon icon="scissors" class="log-icon text-muted" />
      <span>{{ log.schedule0.barber.name }}</span>
    </div>
    <div class="log-row">
      <b-icon icon="clock-fill" class="log-icon text-muted" />
      <span>{{ log.integer0 }} min</span>
    </div>
    <div class="d-flex align-items-center mt-2">
      <b-badge variant="light" pill class="text-muted border">
        <b-icon icon="hash" font-scale="0.8" class="mr-1" />
        {{ log.string1 }}
      </b-badge>
    </div>
  </LogCardWrapper>
</template>

<script>
import LogCardWrapper from './LogCardWrapper'
import DateFormat from '@/Mixins/DateFormat'

export default {
  components: { LogCardWrapper },
  mixins: [DateFormat],
  props: {
    log: { type: Object, required: true },
  },
}
</script>
